import React from "react";
import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

interface LoadingProps {
    variant?: "default" | "inline" | "page";
    className?: string;
    size?: number;
}

export function Loading({ variant = "default", className, size }: LoadingProps) {
    if (variant === "page") {
        return (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm">
                <div className="flex flex-col items-center gap-4">
                    <div className="relative">
                        <div className="absolute inset-0 rounded-full blur-md bg-primary/50 animate-pulse" />
                        <Loader2 className="relative z-10 w-12 h-12 text-primary animate-spin" />
                    </div>
                    <p className="text-sm font-bold tracking-widest text-primary uppercase animate-pulse">Carregando...</p>
                </div>
            </div>
        );
    }

    if (variant === "inline") {
        return <Loader2 className={cn("w-4 h-4 animate-spin text-current", className)} size={size} />;
    }

    // Default block loading
    return (
        <div className={cn("flex items-center justify-center p-8", className)}>
            <Loader2 className={cn("w-8 h-8 animate-spin text-primary", className)} size={size} />
        </div>
    );
}
